"use client";

import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Image from "next/image";
import "./ERPImpactSection.scss";

const ERPImpactSection = ({ impact }) => {
  if (!impact) return null;

  const { title, description, cases } = impact;
  const titleParts = title.split('"');
  const [selectedCase, setSelectedCase] = useState(cases[0]);

  return (
    <section className="impact-section">
      <Container>
        {/* Header */}
        <Row className="impact-header align-items-center">
          <Col xxl={8} xl={6} lg={6} md={6}>
            <div className="text-wrapper">
              <h2 className="impact-title">
               {titleParts[0]}
                <span className="highlight-font">
                  {titleParts[1]}
                </span>
                {titleParts[2]}
              </h2>
            </div>
          </Col>

          <Col xxl={4} xl={5} lg={4} md={4}>
            <div className="text-wrapper">
              <p className="impact-description">{description}</p>
            </div>
          </Col>
        </Row>

        <Row className="align-items-start mt-3">
          <Col lg={3} md={12}>
            <div className="case-sidebar">
              <div className="case-list">
                {cases.map((caseItem) => (
                  <button
                    key={caseItem.id}
                    type="button"
                    className={`case-item ${
                      selectedCase.id === caseItem.id ? "active" : ""
                    }`}
                    onMouseEnter={() => setSelectedCase(caseItem)}
                    onFocus={() => setSelectedCase(caseItem)}
                  >
                    {caseItem.name}
                  </button>
                ))}
              </div>
            </div>
          </Col>

          <Col lg={9} md={12}>
            <div className="case-details">
              {/* Banner Image */}
              <div className="case-image-wrapper">
                <Image
                  src={selectedCase.image}
                  alt={selectedCase.name}
                  fill
                  className="case-image"
                />
              </div>

              <Row className="case-info-grid">
                <Col md={6}>
                  <div className="info-item location-item">
                    <span className="info-label">Location : </span>
                    <span className="info-value">{selectedCase.location}</span>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="info-item industry-item">
                    <span className="info-label">Industry : </span>
                    <span className="info-value">{selectedCase.industry}</span>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ERPImpactSection;
